import React from 'react';

export const Avatar = () => {
    return (
        <picture>
            <source srcSet="assets/images/me.webp" type="image/webp" />
            <img className="avatar rounded-circle" src="assets/images/me.jpg" alt="me" />
        </picture>
    )
}